import { render, staticRenderFns } from "./system_management_section.vue?vue&type=template&id=3da5e816&scoped=true&"
import script from "./system_management_section.vue?vue&type=script&lang=js&"
export * from "./system_management_section.vue?vue&type=script&lang=js&"
import style0 from "./system_management_section.vue?vue&type=style&index=0&id=3da5e816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5e816",
  null
  
)

export default component.exports